











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {ResponsavelHistoricoSms} from '@/model/resource/ResponsavelHistoricoSms'
import {ResponsavelHistoricoSmsCollection} from '@/model/collection/ResponsavelHistoricoSmsCollection'
import {ListResponsavelHistoricoSmsSchema} from '@/schema/resource/ResponsavelHistoricoSms/ListResponsavelHistoricoSmsSchema'
import {CsvResponsavelHistoricoSmsSchema} from '@/schema/resource/ResponsavelHistoricoSms/CsvResponsavelHistoricoSmsSchema'

@Component
export default class ListResponsavelHistoricoSmsView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListResponsavelHistoricoSmsSchema()
  collection = new ResponsavelHistoricoSmsCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: ResponsavelHistoricoSms) {
    Helper.pushByName('editResponsavelHistoricoSms', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ResponsavelHistoricoSmsCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvResponsavelHistoricoSms()
    new CsvResponsavelHistoricoSmsSchema().downloadCsv(csv.all())
  }
}
